import "./FoodActions.css";
import AvailabilityToggle from "../../AvailabilityToggle/AvailabilityToggle";
import {
  MdVisibility,
  MdEdit,
  MdDelete,
  
} from "react-icons/md";

function FoodActions({
  food,
  onView,
  onEdit,
  onDelete,
  onToggleAvailability,
}) {
  return (
    <div className="food-actions">

      <button
        className="view-btn"
        onClick={() => onView(food)}
      >
        <MdVisibility />
      </button>

      <button
        className="edit-btn"
        onClick={() => onEdit(food)}
      >
        <MdEdit />
      </button>

      <button
        className="delete-btn"
        onClick={() => onDelete(food)}
      >
        <MdDelete />
      </button>

     <AvailabilityToggle
  isAvailable={food.isAvailable}
  onToggle={() => onToggleAvailability(food._id)}
/>

    </div>
  );
}

export default FoodActions;